import React from 'react';
import { useOrderStore, Category } from '../../store/orderStore';
import { cn } from '../../lib/utils';

const categories: { id: Category; label: string }[] = [
    { id: 'print', label: '印刷のみ' },
    { id: 'frame', label: '額装' },
    { id: 'mat-processing', label: 'マット加工' },
    { id: 'panel', label: 'パネル加工' },
    { id: 'canvas', label: 'キャンバス張り' },
];

export const CategoryTabs: React.FC = () => {
    const { selectedCategory, setSelectedCategory } = useOrderStore();

    return (
        <div className="w-full border-b border-gray-200 bg-white">
            <div className="flex space-x-8 px-4 overflow-x-auto whitespace-nowrap no-scrollbar md:justify-center">
                {categories.map((category) => (
                    <button
                        key={category.id}
                        onClick={() => setSelectedCategory(category.id)}
                        className={cn(
                            "py-4 px-2 text-sm font-medium border-b-2 transition-colors duration-200",
                            selectedCategory === category.id
                                ? "border-blue-600 text-blue-600"
                                : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                        )}
                    >
                        {category.label}
                    </button>
                ))}
            </div>
        </div>
    );
};
